import * as React from 'react';
import {connect} from 'react-redux';
import * as Locale from '../model/locale';
const logoSrc = require('../assets/img/penn_full_color_logo.png');

@connect(
    state => ({
        currentLanguage: state.data.language,
        user: state.data.user
    })
)

@connect(
    state => ({
        user: state.data.user,
        textForKey: state.data.textForKey
    })
)
export class Footer extends React.Component<any, any> {

    render() {
        let user = this.props.user;
        let legal = null;
        if (!user.features.hide_powered_by) {
            legal =
                <div className="footer-left">
                    <span id="powered">{this.props.textForKey(Locale.TEXT_FOOTER_POWERED_BY)}</span>
                    <img alt="PENN" src={String(logoSrc)}/>
                </div>;
        }

        let links =
             <div className="footer-right">
                 <a href="https://www.johnsoncontrols.com/buildings/legal/digital/generaltos" target="_blank">
                     {this.props.textForKey(Locale.TEXT_FOOTER_TERMS_OF_SERVICE)}
                 </a>
                 <br />
                 <a href="https://www.johnsoncontrols.com/legal/privacy" target="_blank">
                     {this.props.textForKey(Locale.TEXT_FOOTER_PRIVACY_POLICY)}
                 </a>
             </div>;

        return (
            <section id="footer">
                {/* container used to avoid overflow of left and right sections  */}
                <div className="container">
                    {legal}
                    {links}
                </div>
            </section>
        );
    }
}
